/** @returns {unknown[]} */
export const normalizeTranscriptionJobs = (transcription) => {
  if (!transcription) return [];
  if (Array.isArray(transcription)) return transcription;
  return [transcription];
};

const parseJobTime = (value) => {
  if (!value) return null;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
};

/** Order jobs chronologically when timestamps are available. */
export const sortTranscriptionJobs = (jobs) => {
  return [...jobs].sort((a, b) => {
    const timeA = parseJobTime(
      a.job_start_time || a.upload_date || a.audio_upload_date
    );
    const timeB = parseJobTime(
      b.job_start_time || b.upload_date || b.audio_upload_date
    );
    if (timeA != null && timeB != null) return timeA - timeB;
    if (timeA != null) return -1;
    if (timeB != null) return 1;
    const nameA = a.transcribe_job_name || "";
    const nameB = b.transcribe_job_name || "";
    return nameA.localeCompare(nameB);
  });
};

export const getJobTranscriptText = (job) => {
  const text = job?.original_transcript;
  if (text == null) return null;
  const trimmed = String(text).trim();
  return trimmed || null;
};

/**
 * Combine original_transcript from sorted jobs into one readable document.
 * @param {unknown[]} jobs — chronologically sorted transcription jobs
 */
export const buildStitchedTranscript = (jobs) => {
  const segments = jobs
    .map((job, index) => {
      const text = getJobTranscriptText(job);
      if (!text) return null;
      return {
        recordingNumber: index + 1,
        text,
        jobName: job.transcribe_job_name || null,
      };
    })
    .filter(Boolean);

  if (segments.length === 0) {
    return { segments: [], fullText: null, hasGaps: jobs.length > 0 };
  }

  const fullText = segments
    .map(({ recordingNumber, text }) => `Recording ${recordingNumber}\n${text}`)
    .join("\n\n");

  const hasGaps = segments.length < jobs.length;

  return { segments, fullText, hasGaps };
};
